import React, { Component } from "react";
import { connect } from "react-redux";
import '../../../../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import '../../../../../../Assets/EnsembleStyles/ViewTenantDetails.css';
import { Button, Row, Col } from 'reactstrap';
import Conversions from '../../../../../../Resources/Conversions';

class ViewHoursOfOperation extends Component {
  constructor(props){
    super(props);
    this.state = {
      hours_of_operation : this.props.HoursofOperation_response,
      selected_zone: (this.props.TenantAssignedZones.length && this.props.TenantAssignedZones !== undefined && this.props.TenantAssignedZones !== null) ? this.props.TenantAssignedZones[0].props.value : null, 
    };
    this.handleZonesChange = this.handleZonesChange.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
}

componentWillReceiveProps(nextProps) {
  if(this.props !== nextProps) {
    this.setState({  
      hours_of_operation : nextProps.HoursofOperation_response,
      selected_zone: (nextProps.TenantAssignedZones.length && nextProps.TenantAssignedZones !== undefined && nextProps.TenantAssignedZones !== null) ? nextProps.TenantAssignedZones[0].props.value : null,
      });
  }
}

handleZonesChange() {
  var selectedoption = document.getElementById("rdl_Assigned_zones").value;
  this.setState({selected_zone : selectedoption});
}

handleEditClick(){
  this.props.SetSelectedZone(this.state.selected_zone);
  this.props.Display();
}

  render(getLabels,UserCanEdit) {
    let HoursofOperation = null;
    let btn_disable = false;
    let label = this.props.getLabels;
    let AssignedZones = this.props.TenantAssignedZones; 

    let lUserCanEdit = this.props.UserCanEdit;
    lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;
      
    if(AssignedZones !== undefined && AssignedZones !== null && AssignedZones.length)
      btn_disable=false;
    else
      btn_disable=true;


    if(this.state.hours_of_operation.HoursOfOperation != null){
      let FilteredOperation = this.state.hours_of_operation.HoursOfOperation.filter(e => e.zoneId === Number(this.state.selected_zone));
      if (FilteredOperation !== undefined && FilteredOperation !== null && FilteredOperation.length) {
        HoursofOperation = FilteredOperation.sort((a, b) => a.dayId - b.dayId).map(el => {
          if (el.startTime === el.endTime) {
            return <div className="viewlabel" ><label className="leftviewlabel">{Conversions.Weekdays(el.dayId)}</label> <label className="rightviewlabel">none - none</label></div>
          }
          else {
            return <div className="viewlabel" ><label className="leftviewlabel">{Conversions.Weekdays(el.dayId)}</label> <label className="rightviewlabel">{Conversions.UTCdatetoTime(el.startTime)} - {Conversions.UTCdatetoTime(el.endTime)}</label></div>
          }
        });
      }
      else {
        HoursofOperation = <label className="nohoursviewlabel">{label['NormalHours.ViewNoAssignedNormalHours.Text'] !== undefined ? label['NormalHours.ViewNoAssignedNormalHours.Text'] : "There are no Daily Normal Operating Hours assigned to this particular zone. To add Daily Normal Operating Hours, select the 'Edit' button."}</label>
      }
    }

    return (
      <div className="main_container">
        <div className="buttons_container">
          <Row>
            <Col style={{"max-width": this.props.OnPremises ? "15%" :"13%" }}>
              <span style={{"font-size": "13px","position": "relative", "top": "-10px", "color": "black"}}><b>Assigned Zones</b><br/>
                <select id='rdl_Assigned_zones' value={this.state.selected_zone} className="InputFieldStyle" style={{"height":"22px", "width":"150px", "cursor":"pointer", "background-color":"#FFF"}} onChange={this.handleZonesChange}>
                  {AssignedZones}
                </select>
              </span>
            </Col>
            <Col>
              <Button type="button" disabled={btn_disable} hidden={!lUserCanEdit} className="btn btn-black" style={{"float":"left"}} onClick={this.handleEditClick}>{label['ManageTenants.Edit.Text']}</Button>
            </Col>
          </Row>
        </div>
        <br/>
        <div className="headinglabel"><p><b>{label['NormalHours.ViewModeHeading.Text']}</b> </p> </div><br></br>
        {HoursofOperation}
      </div>

    );
  }
}


const mapStateToProps = state => {
  return {
    HoursofOperation_response: state.ViewtenantsRootReducer.HoursofOperation,
    getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
    UserCanEdit: state.authService.HasApplicationFullAcess,
    OnPremises: state.authService.IsOnPremise
  };
};

export default connect(mapStateToProps, null)(ViewHoursOfOperation);